interface GreenTickIconProps {
  width?: string;
  height?: string;
}
export function GreenTickIcon(props: GreenTickIconProps) {
  return (
    <>
      <svg
        width={props.width || "14"}
        height={props.height || "14"}
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          id="Subtract"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.8 6.99922C13.8 10.7548 10.7555 13.7992 7.00001 13.7992C3.24448 13.7992 0.200012 10.7548 0.200012 6.99922C0.200012 3.24368 3.24448 0.199219 7.00001 0.199219C10.7555 0.199219 13.8 3.24368 13.8 6.99922ZM10.5408 5.44005C10.8064 5.1745 10.8064 4.74394 10.5408 4.47839C10.2753 4.21283 9.84474 4.21283 9.57918 4.47839L5.98001 8.07755L4.42085 6.51839C4.15529 6.25283 3.72474 6.25283 3.45918 6.51839C3.19362 6.78394 3.19362 7.21449 3.45918 7.48005L5.49918 9.52005C5.76474 9.78561 6.19529 9.78561 6.46084 9.52005L10.5408 5.44005Z"
          fill="#008367"
        />
      </svg>
    </>
  );
}
